import { useMutation, useQuery } from '@tanstack/react-query'
import { store } from '../..'
import { queryClient } from '../../..'
import { employees } from '../../../api'
import { setAlert, setIsLoading } from '../../components/components-slice'
import { setEmployee } from '../reducer'
import moment from 'moment'
import { setUser } from '../../user/user-slice'
import { setCompany } from '../../company/reducer'
import { updateUser } from '../../user/hook'

export function useGetEmployeeToSelect(limit, page, statusFilter, search) {
  return useQuery(
    ['employee-select', { limit, page, statusFilter, search }],
    () => {
      store.dispatch(setIsLoading(true))
      return employees.getEmployees({ limit, page, statusFilter, search })
    },
    {
      select: (data) => {
        data.data.forEach((employee, index) => {
          employee.employeeName = `${employee.first_name} ${employee.last_name}`
          if (employee.status != 1) {
            data.data.splice(index, 1)
          }
        })
        return data
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

// export function useGetEmployeeToSelectTeam(id) {
//   return useQuery(
//     ['employee-select-team', { id }],
//     () => {
//       store.dispatch(setIsLoading(true))
//       return employees.getEmployeeByTeam(id)
//     },
//     {
//       enabled: id !== null,
//       select: (data) => {
//         data?.data?.forEach((employee, index) => {
//           employee.employeeName = `${employee.first_name} ${employee.last_name}`
//           if (employee.status != 1) {
//             data.data.splice(index, 1)
//           }
//         })
//         return data
//       },
//       onSettled: (data, error, variables, context) => {
//         store.dispatch(setIsLoading(false))
//       },
//     }
//   )
// }

export function useFetchRegistration() {
  return useQuery(
    ['employee-registration'],
    () => {
      store.dispatch(setIsLoading(true))
      return employees.fetchRegistration()
    },
    {
      onSuccess: (response, variables, context) => {
        store.dispatch(setEmployee(response.data))
        store.dispatch(
          setAlert(true, 'success', 'Employee details fetched successfully')
        )
      },
      onSettled: (response, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useGetEmployee() {
  return useQuery(
    ['employee'],
    () => {
      store.dispatch(setIsLoading(true))
      return employees.fetchEmployeeInformation()
    },
    {
      onSuccess: (response, variables, context) => {
        store.dispatch(setEmployee(response.data))
        updateUser({ reload: false })
      },
      onSettled: (response, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useGetEmployeeById(id) {
  return useQuery(
    ['employee', { id }],
    () => {
      store.dispatch(setIsLoading(true))
      return employees.getEmployeeById(id)
    },
    {
      enabled: id !== null,
      onSuccess: (response, variables, context) => {
        store.dispatch(setEmployee(response.data))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useUpdateEmployeeProfile() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return employees.updateEmployeeProfile(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('employees')
        store.dispatch(
          setAlert(
            true,
            'success',
            'Employee profile update request successfully'
          )
        )
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useRegistrationUploadProfilePicture() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return employees.employeeUploadProfilePicture(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useUpdateInvitedEmployees() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return employees.updateInvitedEmployee(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        store.dispatch(setUser(response.data))
        store.dispatch(setCompany(response.data.company))
        store.dispatch(setAlert(true, 'success', response.message))
      },
      onSettled: (response, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useUpdateEmployeeBank() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return employees.updateEmployeeBank(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('employees')
        queryClient.invalidateQueries('employee')
        store.dispatch(
          setAlert(
            true,
            'success',
            'Employee bank information updated successfully'
          )
        )
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}

export function useUpdateEmployee() {
  return useMutation(
    (payload) => {
      store.dispatch(setIsLoading(true))
      return employees.updateEmployee(payload)
    },
    {
      onSuccess: (response, variables, context) => {
        queryClient.invalidateQueries('employees')
        store.dispatch(
          setAlert(true, 'success', 'Employee information updated successfully')
        )
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false))
      },
    }
  )
}
